'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketingBannerList = exports.MarketingBannerChildren = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _BulletListItem = require('acq-components/lib/base-components/BulletListItem/BulletListItem');

var _Typography = require('acq-components/lib/base-components/Typography/Typography');

var _componentHelpers = require('../component-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderColumn = function renderColumn(styles) {
  return function (_ref) {
    var content = _ref.content;

    var itemsWithDesc = (content || []).filter(function (i) {
      return !!i.desc;
    });
    var rowClassName = (0, _lodash2.default)(styles, 'rewardsBanner.bulletListItemContainer');
    var bulletStyle = styles.accordionContentItem;

    return itemsWithDesc.map(function (item, index) {
      return _react2.default.createElement(
        'div',
        { className: rowClassName, key: index },
        _react2.default.createElement(
          _BulletListItem.BulletListItem,
          { image: (0, _componentHelpers.getIconOrImage)(item), styles: bulletStyle },
          item.header && _react2.default.createElement(_Typography.Typography, {
            className: (0, _lodash2.default)(styles, 'rewardsBanner.columnHeader'),
            components: { columnHeader: item.header },
            Component: 'h3',
            styles: styles.rewardsBanner
          }),
          _react2.default.createElement(_componentHelpers.DescParser, { descArray: item.desc, InnerTag: 'span' })
        )
      );
    });
  };
};

var getColumnComponent = function getColumnComponent(columnRenderer) {
  return function (col, index) {
    return _react2.default.createElement(
      'div',
      { className: 'two-column__' + (index && !(index % 2) ? 'right' : 'left') },
      columnRenderer(col)
    );
  };
};

var MarketingBannerChildren = exports.MarketingBannerChildren = function MarketingBannerChildren(_ref2) {
  var content = _ref2.content,
      styles = _ref2.styles;

  if (!content.length) return null;

  var columnRenderer = renderColumn(styles);

  return _react2.default.createElement(
    'div',
    { className: (0, _lodash2.default)(styles, 'rewardsBanner.bulletListContainer') },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)((0, _lodash2.default)(styles, 'rewardsBanner.bulletListContainer'), 'two-column')
      },
      (content || []).map(getColumnComponent(columnRenderer))
    )
  );
};

var MarketingBannerList = exports.MarketingBannerList = function MarketingBannerList(_ref3) {
  var listItems = _ref3.listItems,
      styles = _ref3.styles;
  return _react2.default.createElement(
    'ul',
    { className: (0, _lodash2.default)(styles, 'rewardsBanner.listContainer') },
    listItems.map(function (listItem) {
      return _react2.default.createElement(
        'li',
        null,
        listItem.text
      );
    })
  );
};